export default __webpack_public_path__ + "static/media/gs-persona-2.c09c59fd.webp";